'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FollowerChannels = exports.FollowersGrowthComponent = exports.FollowersCountComponent = exports.RowAssets = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _uuid = require('uuid');

var _uuid2 = _interopRequireDefault(_uuid);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _semanticUiReact = require('semantic-ui-react');

var _formatting = require('../../utils/formatting');

var _colors = require('./../../utils/colors');

var _dyzioIcons = require('../../components/dyzio-icons');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var platforms = ['instagram', 'facebook', 'twitter', 'youtube', 'tiktok', 'twitch', 'telegram'];

var getDyzioIcon = function getDyzioIcon(platform) {
  if (_lodash2.default.isEqual(platform, 'instagram')) return _react2.default.createElement(_dyzioIcons.InstagramIcon, null);
  if (_lodash2.default.isEqual(platform, 'facebook')) return _react2.default.createElement(_dyzioIcons.FacebookIcon, null);
  if (_lodash2.default.isEqual(platform, 'twitter')) return _react2.default.createElement(_dyzioIcons.TwitterIcon, null);
  if (_lodash2.default.isEqual(platform, 'youtube')) return _react2.default.createElement(_dyzioIcons.YoutubeIcon, null);
  if (_lodash2.default.isEqual(platform, 'tiktok')) return _react2.default.createElement(_dyzioIcons.TiktokIcon, null);
  if (_lodash2.default.isEqual(platform, 'twitch')) return _react2.default.createElement(_dyzioIcons.TwitchIcon, null);
  if (_lodash2.default.isEqual(platform, 'telegram')) return _react2.default.createElement(_dyzioIcons.TelegramIcon, null);
  return null;
};

var hasNoAssets = function hasNoAssets(array) {
  return _lodash2.default.isUndefined(_lodash2.default.find(array, function (i) {
    return i > 0;
  }));
};

var tableStyle = { marginBottom: 0 };
var avatarStyle = {
  width: 50,
  height: 50,
  margin: 'auto'
};

var influencerNameStyle = {
  fontSize: 16,
  marginLeft: 8,
  marginBottom: -4,
  marginTop: 4,
  margin: 'auto'
};

var influnecerHandleStyle = {
  marginLeft: 8,
  marginTop: 3,
  margin: 'auto'
};

var RowAssets = exports.RowAssets = function RowAssets(_ref) {
  var facebook = _ref.facebook,
      twitter = _ref.twitter,
      instagram = _ref.instagram,
      youtube = _ref.youtube,
      tiktok = _ref.tiktok;

  var noAssets = hasNoAssets([facebook.count, instagram.images, instagram.videos, instagram.stories, instagram.carousels, instagram.igtvs, twitter.count, youtube.count, tiktok.count]);
  var tiktokIconStyle = {
    marginLeft: 0,
    marginTop: 0,
    marginBottom: 0,
    marginRight: 2
  };
  return _react2.default.createElement(
    _semanticUiReact.List,
    null,
    noAssets && _react2.default.createElement(
      _semanticUiReact.List.Item,
      null,
      '-'
    ),
    facebook && facebook.count > 0 && _react2.default.createElement(
      _semanticUiReact.List.Item,
      null,
      facebook.count,
      ' x ',
      _react2.default.createElement(_semanticUiReact.Icon, { name: 'facebook' }),
      ' POST '
    ),
    instagram && instagram.images > 0 && _react2.default.createElement(
      _semanticUiReact.List.Item,
      null,
      instagram.images,
      ' x ',
      _react2.default.createElement(_semanticUiReact.Icon, { name: 'instagram' }),
      ' POST '
    ),
    instagram && instagram.videos > 0 && _react2.default.createElement(
      _semanticUiReact.List.Item,
      null,
      instagram.videos,
      ' x ',
      _react2.default.createElement(_semanticUiReact.Icon, { name: 'instagram' }),
      ' VIDEO '
    ),
    instagram && instagram.stories > 0 && _react2.default.createElement(
      _semanticUiReact.List.Item,
      null,
      instagram.stories,
      ' x ',
      _react2.default.createElement(_semanticUiReact.Icon, { name: 'instagram' }),
      ' STORY '
    ),
    instagram && instagram.carousels > 0 && _react2.default.createElement(
      _semanticUiReact.List.Item,
      null,
      instagram.carousels,
      ' x ',
      _react2.default.createElement(_semanticUiReact.Icon, { name: 'instagram' }),
      ' CAROUSEL '
    ),
    instagram && instagram.igtvs > 0 && _react2.default.createElement(
      _semanticUiReact.List.Item,
      null,
      instagram.igtvs,
      ' x ',
      _react2.default.createElement(_semanticUiReact.Icon, { name: 'instagram' }),
      ' IGTV '
    ),
    instagram && instagram.reels > 0 && _react2.default.createElement(
      _semanticUiReact.List.Item,
      null,
      instagram.reels,
      ' x ',
      _react2.default.createElement(_semanticUiReact.Icon, { name: 'instagram' }),
      ' REEL '
    ),
    twitter && twitter.count > 0 && _react2.default.createElement(
      _semanticUiReact.List.Item,
      null,
      twitter.count,
      ' x ',
      _react2.default.createElement(_semanticUiReact.Icon, { name: 'twitter' }),
      ' TWEET '
    ),
    youtube && youtube.count > 0 && _react2.default.createElement(
      _semanticUiReact.List.Item,
      null,
      youtube.count,
      ' x ',
      _react2.default.createElement(_semanticUiReact.Icon, { name: 'youtube' }),
      ' VIDEO '
    ),
    tiktok && tiktok.count > 0 && _react2.default.createElement(
      _semanticUiReact.List.Item,
      null,
      tiktok.count,
      ' x ',
      _react2.default.createElement(_dyzioIcons.TiktokIcon, { additionalStyles: tiktokIconStyle }),
      '  VIDEO '
    )
  );
};

RowAssets.propTypes = {
  youtube: _propTypes2.default.object.isRequired,
  instagram: _propTypes2.default.object.isRequired,
  facebook: _propTypes2.default.object.isRequired,
  twitter: _propTypes2.default.object.isRequired,
  tiktok: _propTypes2.default.object.isRequired
};

var FollowersCountComponent = exports.FollowersCountComponent = function FollowersCountComponent(_ref2) {
  var initialFollowerCounts = _ref2.initialFollowerCounts,
      latestFollowerCounts = _ref2.latestFollowerCounts;

  console.log(initialFollowerCounts);
  console.log(latestFollowerCounts);
  return _react2.default.createElement(
    _semanticUiReact.List,
    null,
    _lodash2.default.map(platforms, function (p) {
      if (latestFollowerCounts[p + 'Count']) {
        return _react2.default.createElement(
          _semanticUiReact.List.Item,
          null,
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { textAlign: 'center' },
            (0, _formatting.paidReportFormat)(_lodash2.default.get(initialFollowerCounts, p + 'Count', '-'))
          )
        );
      }
      return null;
    })
  );
};

FollowersCountComponent.propTypes = {
  initialFollowerCounts: _propTypes2.default.object.isRequired,
  latestFollowerCounts: _propTypes2.default.object.isRequired
};

var getGrowthValue = function getGrowthValue(lfc, ifc, p) {
  return _lodash2.default.get(lfc, p + 'Count', 0) - _lodash2.default.get(ifc, p + 'Count', 0);
};

var FollowersGrowthComponent = exports.FollowersGrowthComponent = function FollowersGrowthComponent(_ref3) {
  var initialFollowerCounts = _ref3.initialFollowerCounts,
      latestFollowerCounts = _ref3.latestFollowerCounts;

  console.log(initialFollowerCounts);
  console.log(latestFollowerCounts);
  var increaseStyle = {
    color: _colors.dyzioPalette.green
  };
  var decreaseStyle = {
    color: 'red'
  };

  var getGrowthStyle = function getGrowthStyle(growth) {
    if (growth > 0) return increaseStyle;
    if (growth < 0) return decreaseStyle;
    return null;
  };

  return _react2.default.createElement(
    _semanticUiReact.List,
    null,
    _lodash2.default.map(platforms, function (p) {
      if (latestFollowerCounts[p + 'Count']) {
        var growthValue = getGrowthValue(latestFollowerCounts, initialFollowerCounts, p);
        var growthPercentage = growthValue !== 0 ? (0, _formatting.percentFormatted1dp)(growthValue / _lodash2.default.get(latestFollowerCounts, p + 'Count', 0) * 100) + '%' : '-';
        var growth = '';
        if (_lodash2.default.get(initialFollowerCounts, p + 'Count')) {
          if (growthValue > 0) growth = '+';
        }

        var ifc = _lodash2.default.get(initialFollowerCounts, p + 'Count');
        return _react2.default.createElement(
          _semanticUiReact.List.Item,
          null,
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { textAlign: 'center', style: getGrowthStyle(growthValue) },
            growth,
            ifc ? (0, _formatting.paidReportFormat)(growthValue) : '-',
            '/',
            growthPercentage
          )
        );
      }
      return null;
    })
  );
};

FollowersGrowthComponent.propTypes = {
  initialFollowerCounts: _propTypes2.default.object.isRequired,
  latestFollowerCounts: _propTypes2.default.object.isRequired
};

var FollowerChannels = exports.FollowerChannels = function FollowerChannels(_ref4) {
  var latestFollowerCounts = _ref4.latestFollowerCounts;

  console.log(latestFollowerCounts);
  var tiktokIconStyle = {
    marginLeft: 0,
    marginTop: 0,
    marginBottom: 0,
    marginRight: 2
  };
  var textAlignRight = {
    'text-align': 'right',
    paddingLeft: 30
  };
  var truncateTextStyle = {
    'white-space': 'nowrap',
    overflow: 'hidden',
    'text-overflow': 'ellipsis'
  };
  return _react2.default.createElement(
    _semanticUiReact.List,
    null,
    _lodash2.default.map(platforms, function (p) {
      if (latestFollowerCounts[p + 'Count']) {
        if (_lodash2.default.isEqual(p, 'tiktok')) {
          return _react2.default.createElement(
            _semanticUiReact.List.Item,
            null,
            _react2.default.createElement(
              'span',
              { style: textAlignRight },
              _react2.default.createElement(_dyzioIcons.TiktokIcon, { style: tiktokIconStyle })
            ),
            _react2.default.createElement(
              'span',
              { style: truncateTextStyle },
              _lodash2.default.get(latestFollowerCounts, 'tiktok', '-')
            )
          );
        }
        return _react2.default.createElement(
          _semanticUiReact.List.Item,
          null,
          _react2.default.createElement(
            'span',
            { style: textAlignRight },
            getDyzioIcon(p)
          ),
          _react2.default.createElement(
            'span',
            { style: truncateTextStyle },
            _lodash2.default.get(latestFollowerCounts, '' + p, '-')
          )
        );
      }
      return null;
    })
  );
};

FollowerChannels.propTypes = {
  latestFollowerCounts: _propTypes2.default.object.isRequired
};

var twoRowsModeArrowStyle = {
  color: 'gray',
  display: 'block',
  float: 'right',
  marginLeft: -22,
  marginTop: -3,
  marginRight: -10
};

var oneRowModeArrowStyle = (0, _extends3.default)({}, twoRowsModeArrowStyle, {
  marginTop: 3
});

var SortArrow = function SortArrow(_ref5) {
  var field = _ref5.field,
      order = _ref5.order,
      targetField = _ref5.targetField,
      twoRowsMode = _ref5.twoRowsMode;

  var shouldRenderIcon = _lodash2.default.eq(field, targetField);
  if (shouldRenderIcon) {
    return _react2.default.createElement(_semanticUiReact.Icon, {
      name: 'angle ' + (order === 'asc' ? 'up' : 'down'),
      style: twoRowsMode ? twoRowsModeArrowStyle : oneRowModeArrowStyle,
      size: 'small'
    });
  }
  return null;
};

SortArrow.propTypes = {
  field: _propTypes2.default.string.isRequired,
  order: _propTypes2.default.oneOf(['asc', 'desc']).isRequired,
  targetField: _propTypes2.default.string.isRequired,
  twoRowsMode: _propTypes2.default.boolean
};

SortArrow.defaultProps = {
  twoRowsMode: false
};

var ReportTableHeader = function ReportTableHeader(_ref6) {
  var onSortChanged = _ref6.onSortChanged,
      sort = _ref6.sort,
      initialDate = _ref6.initialDate,
      latestDate = _ref6.latestDate;
  return _react2.default.createElement(
    _semanticUiReact.Table.Header,
    null,
    _react2.default.createElement(
      _semanticUiReact.Table.HeaderCell,
      {
        width: 2,
        onClick: function onClick() {
          return onSortChanged('name');
        },
        textAlign: 'center'
      },
      'influencer ',
      _react2.default.createElement(SortArrow, (0, _extends3.default)({ targetField: 'name' }, sort))
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.HeaderCell,
      {
        width: 2
      },
      'content'
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.HeaderCell,
      {
        width: 3,
        textAlign: 'center'
      },
      'channels'
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.HeaderCell,
      {
        width: 2,
        textAlign: 'center'
      },
      'FC (start)',
      _react2.default.createElement(
        'p',
        { style: { color: 'grey' } },
        (0, _moment2.default)(initialDate).format('YYYY-MM-DD')
      )
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.HeaderCell,
      {
        width: 2,
        textAlign: 'center'
      },
      'FC (end)',
      _react2.default.createElement(
        'p',
        { style: { color: 'grey' } },
        (0, _moment2.default)(latestDate).format('YYYY-MM-DD')
      )
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.HeaderCell,
      {
        width: 2,
        textAlign: 'center'
      },
      'FC (change)',
      _react2.default.createElement(
        'p',
        { style: { color: 'grey' } },
        'abs / %'
      )
    )
  );
};

ReportTableHeader.propTypes = {
  onSortChanged: _propTypes2.default.func.isRequired
};

var clientRowStyle = { backgroundColor: '#ffecf3' };

var ReportRow = function ReportRow(_ref7) {
  var id = _ref7.id,
      name = _ref7.name,
      thumbnail = _ref7.thumbnail,
      influencerName = _ref7.influencerName,
      trackedAssetsStats = _ref7.trackedAssetsStats,
      initialFollowerCounts = _ref7.initialFollowerCounts,
      latestFollowerCounts = _ref7.latestFollowerCounts,
      isClientDiscussion = _ref7.isClientDiscussion;
  return _react2.default.createElement(
    _semanticUiReact.Table.Row,
    { key: id, style: isClientDiscussion ? clientRowStyle : {} },
    _react2.default.createElement(
      _semanticUiReact.Table.Cell,
      { textAlign: 'center' },
      _react2.default.createElement(_semanticUiReact.Image, {
        src: thumbnail,
        className: 'circular',
        style: avatarStyle
      }),
      _react2.default.createElement(
        'div',
        { style: influencerNameStyle },
        _lodash2.default.truncate(influencerName, { length: 20 })
      ),
      _react2.default.createElement(
        'div',
        { style: influnecerHandleStyle },
        _lodash2.default.truncate(name, { length: 24 })
      ),
      isClientDiscussion && _react2.default.createElement(
        _semanticUiReact.Label,
        null,
        'CLIENT'
      )
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.Cell,
      null,
      _react2.default.createElement(RowAssets, trackedAssetsStats)
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.Cell,
      null,
      _react2.default.createElement(FollowerChannels, {
        latestFollowerCounts: latestFollowerCounts
      })
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.Cell,
      null,
      _react2.default.createElement(FollowersCountComponent, {
        initialFollowerCounts: initialFollowerCounts,
        latestFollowerCounts: latestFollowerCounts
      })
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.Cell,
      null,
      _react2.default.createElement(FollowersCountComponent, {
        initialFollowerCounts: latestFollowerCounts,
        latestFollowerCounts: latestFollowerCounts
      })
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.Cell,
      null,
      _react2.default.createElement(FollowersGrowthComponent, {
        initialFollowerCounts: initialFollowerCounts,
        latestFollowerCounts: latestFollowerCounts
      })
    )
  );
};

ReportRow.propTypes = {
  id: _propTypes2.default.string.isRequired,
  name: _propTypes2.default.string.isRequired,
  trackedAssetsStats: _propTypes2.default.object.isRequired,
  thumbnail: _propTypes2.default.string.isRequired,
  influencerName: _propTypes2.default.string.isRequired,
  isClientDiscussion: _propTypes2.default.bool.isRequired,
  initialFollowerCounts: _propTypes2.default.object.isRequired,
  latestFollowerCounts: _propTypes2.default.object.isRequired
};

var reverseOrder = function reverseOrder() {
  var order = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'asc';

  if (order === 'asc') {
    return 'desc';
  }
  return 'asc';
};

var FollowersReport = function (_Component) {
  (0, _inherits3.default)(FollowersReport, _Component);

  function FollowersReport(props) {
    (0, _classCallCheck3.default)(this, FollowersReport);

    var _this = (0, _possibleConstructorReturn3.default)(this, (FollowersReport.__proto__ || (0, _getPrototypeOf2.default)(FollowersReport)).call(this, props));

    _this.onSortFieldChange = function (field) {
      _this.setState({
        sort: {
          field: field,
          order: reverseOrder(_this.state.sort.order)
        }
      });
    };

    _this.state = {
      sort: {
        field: 'costs.costPerEngagement',
        order: 'asc'
      }
    };
    return _this;
  }

  (0, _createClass3.default)(FollowersReport, [{
    key: 'render',
    value: function render() {
      var sort = this.state.sort;
      var _props = this.props,
          currency = _props.currency,
          reportData = _props.reportData,
          onFilterChange = _props.onFilterChange,
          filter = _props.filter;


      var isEmptyReport = _lodash2.default.isEmpty(reportData);

      var reportRows = reportData;
      var isFiltered = false;

      if (_lodash2.default.get(filter, 'basic.handle', false)) {
        isFiltered = true;
        reportRows = _lodash2.default.filter(reportRows, ['name', _lodash2.default.get(filter, 'basic.handle')]);
      }

      var influencerNames = _lodash2.default.map(reportData, 'name');
      var sortedReportRows = _lodash2.default.orderBy(reportRows, ['isClientDiscussion', sort.field], ['desc', sort.order]);

      var firstRow = _lodash2.default.head(sortedReportRows);
      var initialDate = firstRow && firstRow.initialFollowerCounts.createdDate;
      var latestDate = firstRow && firstRow.latestFollowerCounts.createdDate;
      return _react2.default.createElement(
        'div',
        null,
        isEmptyReport && _react2.default.createElement(_semanticUiReact.Message, null),
        !isEmptyReport && _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            _semanticUiReact.Menu,
            null,
            _react2.default.createElement(
              _semanticUiReact.Menu.Menu,
              null,
              _react2.default.createElement(
                _semanticUiReact.Menu.Item,
                null,
                _react2.default.createElement(
                  'strong',
                  null,
                  'FILTER BY:'
                )
              )
            ),
            _react2.default.createElement(
              _semanticUiReact.Menu.Menu,
              null,
              _react2.default.createElement(
                _semanticUiReact.Dropdown,
                { scrolling: true, item: true, text: isFiltered ? filter.basic.handle : 'influencer' },
                _react2.default.createElement(
                  _semanticUiReact.Dropdown.Menu,
                  null,
                  isFiltered && _react2.default.createElement(
                    _semanticUiReact.Dropdown.Item,
                    {
                      onClick: function onClick(event) {
                        return onFilterChange(event, { value: 'handle.reset' });
                      },
                      value: 'discussion.reset'
                    },
                    _react2.default.createElement(_semanticUiReact.Icon, { name: 'close', size: 'tiny' }),
                    'reset'
                  ),
                  _lodash2.default.map(influencerNames, function (name) {
                    return _react2.default.createElement(
                      _semanticUiReact.Dropdown.Item,
                      {
                        onClick: function onClick(event) {
                          return onFilterChange(event, { value: 'handle.' + name });
                        },
                        value: 'discussion'
                      },
                      _react2.default.createElement(_semanticUiReact.Icon, { name: 'user', size: 'tiny' }),
                      ' ',
                      _lodash2.default.toLower(name)
                    );
                  })
                )
              )
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Card,
            { fluid: true, color: 'green' },
            _react2.default.createElement(
              _semanticUiReact.Table,
              { sortable: true, basic: 'very', singleLine: true, celled: true, style: tableStyle },
              _react2.default.createElement(ReportTableHeader, {
                onSortChanged: this.onSortFieldChange,
                sort: sort,
                initialDate: initialDate,
                latestDate: latestDate
              }),
              _react2.default.createElement(
                _semanticUiReact.Table.Body,
                null,
                _lodash2.default.map(sortedReportRows, function (row) {
                  return _react2.default.createElement(ReportRow, (0, _extends3.default)({ key: (0, _uuid2.default)() }, row, { currency: currency }));
                })
              )
            ),
            _react2.default.createElement(
              _semanticUiReact.Card.Content,
              { extra: true },
              _react2.default.createElement(
                'div',
                { className: 'ui right aligned' },
                'Report generated at ',
                _react2.default.createElement(
                  'strong',
                  null,
                  (0, _moment2.default)().format('MMMM Do YYYY, h:mm a')
                ),
                '.'
              )
            )
          )
        )
      );
    }
  }]);
  return FollowersReport;
}(_react.Component);

FollowersReport.propTypes = {
  onFilterChange: _propTypes2.default.func,
  currency: _propTypes2.default.string.isRequired,
  filter: _propTypes2.default.object.isRequired,
  reportData: _propTypes2.default.object.isRequired
};

FollowersReport.defaultProps = {
  onFilterChange: _lodash2.default.noop
};

exports.default = FollowersReport;


//////////////////
// WEBPACK FOOTER
// ./node_modules/dyzio-shared-components/lib/reports/followers-report/index.js
// module id = 2207
// module chunks = 1